/*
 * GP instant cart (2026-10-12). Optimistic UI on top of the theme's cart code:
 *  - Add to Cart (PDP button, free-pair "+", recommendation / collection / upsell adds): on the tap itself the drawer opens
 *    with the new line, predicted line prices and totals (from the ladder in #gp-offer-config), the progress bar, the item
 *    count and the add button label; the theme's own /cart/add.js + section re-render then replaces it with the server truth.
 *  - Drawer + / - / remove: applied to the DOM immediately; the network call is debounced (300 ms) and sent once.
 *  - No spinners or overlays (CSS in snippets/gp-cart-instant.liquid). If the server refuses an add, the predicted line is
 *    removed and the button reads "Couldn't add — tap to retry".
 * Reads GPPrice (assets/gp-pricing.js) for the ladder, the prefetched cart and the button labels. Never computes prices itself.
 */
(function () {
  if (window.GPInstant) return;
  var GP = function () { return window.GPPrice && window.GPPrice.ready ? window.GPPrice : null; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { c = Number(c); if (!isFinite(c)) return ''; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var drawer = function () { return document.getElementById('shopify-section-cart-drawer'); };
  var lastTap = 0;

  // ---------- what the cart will look like after a change (counts per scope, totals) ----------
  var opt = { n: 0, r: 0, nonOffer: 0, baseSum: 0, count: 0 }; // optimistic changes not yet confirmed by a cart read
  document.addEventListener('gp:cart', function (e) { if (!(e.detail && e.detail.optimistic)) { opt = { n: 0, r: 0, nonOffer: 0, baseSum: 0, count: 0 }; try { paintUpsells(snapshot()); } catch (err) {} } });
  document.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('#shopify-section-cart-drawer [data-gp-upsell-tap]')) { e.preventDefault(); e.target.click(); } });
  function snapshot() {
    var gp = GP(); var cart = gp && gp.state.cart;
    var s = { n: opt.n, r: opt.r, nonOffer: opt.nonOffer, baseSum: opt.baseSum, count: opt.count };
    if (cart && cart.items) cart.items.forEach(function (it) {
      s.count += it.qty; s.baseSum += (it.base || 0);
      if (it.scope === 'b1g2') s.n += it.qty; else if (it.scope === 'readers3') s.r += it.qty; else s.nonOffer += (it.base || 0);
    });
    return s;
  }
  function totals(s) {
    var gp = GP(); if (!gp) return null;
    var total = gp.expectedTotal('b1g2', s.n) + gp.expectedTotal('readers3', s.r) + s.nonOffer;
    return { total: total, savings: Math.max(0, s.baseSum - total) };
  }
  // price the NEXT unit of a scope pays (Shopify prices pairs in the order they were added)
  function nextUnitPrice(scope, s, base) {
    var gp = GP(); if (!gp) return base;
    if (scope === 'b1g2') return Math.min(base, gp.expectedTotal('b1g2', s.n + 1) - gp.expectedTotal('b1g2', s.n));
    if (scope === 'readers3') return Math.min(base, gp.expectedTotal('readers3', s.r + 1) - gp.expectedTotal('readers3', s.r));
    return base;
  }

  // ---------- DOM painting ----------
  function paintTotals(s) {
    var d = drawer(); var t = totals(s); if (!d || !t) return;
    var rows = $$('.cart_drawer_items_row', d);
    rows.forEach(function (row) {
      var lbl = (row.querySelector('.cart_drawer_items_label') || {}).textContent || '';
      var val = row.querySelector('.cart_drawer_items_count');
      if (!val) return;
      if (/ITEMS/i.test(lbl)) val.textContent = String(s.count);
      if (/SHIPPING/i.test(lbl)) val.textContent = 'FREE';
      if (/SAVINGS/i.test(lbl)) { val.textContent = '−' + money(t.savings); row.style.display = t.savings > 0 ? '' : 'none'; }
    });
    var tp = $('.cart_drawer_total_price', d); if (tp) tp.textContent = money(t.total);
    $$('[data-bind="itemCount"]').forEach(function (el) { el.textContent = String(s.count); el.style.display = s.count > 0 ? '' : 'none'; });
  }
  function paintProgress(s) {
    var d = drawer(); var gp = GP(); if (!d || !gp) return;
    var row = $('.gp-offer-row[data-gp-scope="b1g2"]', d); if (!row) return;
    var txt = gp.text && gp.text.step ? gp.text.step[String(Math.min(Math.max(s.n, 0), 4))] : '';
    var sub = $('.gp-offer-sub', row); if (sub && txt) sub.textContent = txt;
    $$('.gp-step', row).forEach(function (el, i) { el.classList.toggle('on', s.n >= i + 1); });
    $$('.gp-bar', row).forEach(function (el, i) { el.classList.toggle('on', s.n >= i + 2); });
    row.classList.toggle('is-done', s.n >= 3);
    var wrap = row.closest('.gp-offer'); if (wrap) wrap.classList.toggle('is-done', s.n >= 3);
    var up = $('.cart_drawer_upsells_heading', d);
    if (up && gp.text && gp.text.upsell) up.textContent = s.n >= 3 ? gp.text.upsell.at3 : gp.text.upsell.under3;
  }
  // upsell cards: the price under each card = what the NEXT pair of that scope costs now (FREE / $15), list price struck
  function paintUpsells(s) {
    var d = drawer(); var gp = GP(); if (!d || !gp) return;
    $$('[data-gp-upsell]', d).forEach(function (card) {
      var scope = card.getAttribute('data-gp-scope') || ''; var base = +card.getAttribute('data-gp-base') || 0; if (!base) return;
      var price = nextUnitPrice(scope, s, base);
      var now = card.querySelector('.gp-upcard__now'), was = card.querySelector('.gp-upcard__was');
      if (now) { var t = price === 0 ? 'FREE' : money(price); if (now.textContent !== t) now.textContent = t; now.classList.toggle('is-free', price === 0); }
      if (was) was.hidden = !(price < base);
    });
  }
  function paintButtons(s) {
    var gp = GP(); if (!gp) return;
    gp.state.n = s.n; gp.state.r = s.r; // other snippets (free-pair picker, bottom bar, product cards) follow the optimistic count
    try { gp.paint(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('gp:cart', { detail: { n: s.n, r: s.r, optimistic: true } })); } catch (e) {}
  }
  // same rule as GPPrice.paintLineBadges: the badge follows the row's own price ($0 -> FREE, extra price -> EXTRA PAIR, paid -> SAVE)
  function lineBadge(scope, price, base, n) {
    var gp = GP(); var b = gp && gp.lineBadgeFor ? gp.lineBadgeFor(scope, base, price, n, 1) : null;
    if (!b) return null;
    return { cls: b.tone === 'green' ? 'gp_free_badge' : (b.msg ? 'gp-msg' : ''), text: b.text };
  }
  function lineHTML(p, n) {
    var badge = lineBadge(p.scope, p.price, p.base, n);
    return '<div class="cart_drawer_item" data-gp-line data-gp-optimistic data-gp-scope="' + esc(p.scope || '') + '" data-gp-handle="' + esc(p.handle || '') + '" data-gp-final="' + Number(p.price || 0) + '">' +
      '<div class="cart_item_image_wrapper">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" class="cart_item_image" width="80" height="80">' : '') + '</div>' +
      '<div class="cart_drawer_item_details"><div class="cart_drawer_item_title_row"><a class="cart_drawer_item_title" href="' + esc(p.url || '#') + '">' + esc(p.title) + '</a>' +
      (badge ? '<span class="cart_drawer_item_discount_badge bogo_badge ' + badge.cls + '" data-gp-kind="' + (badge.cls === 'gp_free_badge' ? 'free' : /EXTRA/i.test(badge.text) ? 'extra' : 'save') + '" data-gp-line-badge-optimistic>' + esc(badge.text) + '</span>' : '') + '</div>' +
      '<div class="cart_drawer_item_price csapp-price"><div class="cart-item__discounted-prices"><strong class="bold-price">' + (p.price === 0 ? '$0' : money(p.price)) + '</strong>' +
      (p.price < p.base ? '<s class="compare-price price-was">' + money(p.base) + '</s>' : '') + '</div>' +
      '</div></div>' +
      '<div class="cart_drawer_item_right_col"><div class="cart_drawer_item_qty_selector"><div class="cart_drawer_item_plus_minus"><div class="cart_drawer_item_plus_minus_container">' +
      '<div class="cart_item_quantity_update gp-opt-disabled">−</div><div class="cart_drawer_item_quantity">1</div><div class="cart_item_quantity_update gp-opt-disabled">+</div></div></div></div></div></div>';
  }
  function insertLine(p, n) {
    var d = drawer(); if (!d) return false;
    var list = $('.cart_drawer_items_container', d);
    if (!list) {
      // empty cart: swap the empty message for a minimal list + total until the real render arrives
      var main = $('.cart_drawer_main_container', d); if (!main) return false;
      main.classList.remove('cart_drawer_main_container--empty');
      var empty = $('.cd_empty_message', main); if (empty) empty.remove();
      main.insertAdjacentHTML('afterbegin', '<div class="cart_drawer_items gp-opt-shell"><div class="cart_drawer_items_container"></div></div>' +
        '<div class="cart_drawer_footer gp-opt-shell"><div class="cart_drawer_summary"><div class="cart_drawer_items_row"><div class="cart_drawer_items_label">ITEMS</div><div class="cart_drawer_items_count">1</div></div>' +
        '<div class="cart_drawer_items_row free_shipping_bar"><div class="cart_drawer_items_label">SHIPPING</div><div class="cart_drawer_items_count">FREE</div></div>' +
        '<div class="cart_drawer_total_container cart_drawer_total_row"><div class="cart_drawer_total_text">TOTAL</div><div class="cart_drawer_total_price">' + money(p.price) + '</div></div></div></div>');
      list = $('.cart_drawer_items_container', d);
    }
    list.insertAdjacentHTML('afterbegin', lineHTML(p, n));
    return true;
  }

  // ---------- product facts for the tapped button ----------
  function productFor(btn) {
    var p = { variant: btn.getAttribute('data-variant-id'), title: '', image: '', url: '', handle: '', base: 0, scope: null };
    var form = btn.closest('form[action*="/cart/add"]');
    if (!p.variant && form) { var idEl = form.querySelector('[name="id"]'); p.variant = idEl && idEl.value; }
    var ladder;
    if (btn.classList.contains('gp-atc') || (form && btn.type === 'submit')) {
      // product page main button
      var h1 = $('.gp-title'); p.title = h1 ? h1.textContent.trim() : document.title.split('–')[0].trim();
      p.handle = h1 ? h1.getAttribute('data-handle') || '' : ''; p.url = location.pathname;
      // the product's hero image (preloaded by theme.liquid), never the first <img> on the page (that is the POLARIZED badge)
      var pre = $('link[data-gp-hero-preload]'); p.image = pre ? pre.getAttribute('href') : '';
      if (!p.image) { var cand = $$('.gp-gallery img, .gp-pdp img, .product__media img').filter(function (im) { var src = im.currentSrc || im.src || ''; return src && !/polari|badge|icon|logo|xl[-_]/i.test(src) && im.getBoundingClientRect().width > 120; }); p.image = cand[0] ? (cand[0].currentSrc || cand[0].src) : ''; }
      ladder = $('.gp-price [data-gp-ladder]');
    } else {
      var card = btn.closest('.fp__card, .productCard, .new_product_card, .cart_drawer_upsell, .gp-tcard, .gp-cmp__col, [data-gp-ladder-card]') || btn.parentElement;
      var t = card && (card.querySelector('.fp__name, .productCard__title, .product-info-title, .cart_drawer_upsell_title, .gp-tcard__name, .gp-cmp__name') || card.querySelector('img[alt]'));
      p.title = t ? (t.tagName === 'IMG' ? t.alt : t.textContent.trim()) : (btn.getAttribute('aria-label') || '').replace(/^Add\s+/i, '').replace(/\s+to cart.*$/i, '');
      var ci = card && card.querySelector('img'); p.image = ci ? ci.currentSrc || ci.src : '';
      var a = card && card.querySelector('a[href*="/products/"]'); p.url = a ? a.getAttribute('href') : '';
      p.handle = card ? card.getAttribute('data-id') || card.getAttribute('data-handle') || '' : '';
      ladder = card && card.querySelector('[data-gp-ladder]');
      if (!p.handle && p.url) p.handle = p.url.split('/products/')[1] ? p.url.split('/products/')[1].split(/[?#]/)[0] : '';
    }
    if (ladder) { p.scope = ladder.getAttribute('data-gp-scope') || null; p.base = +ladder.getAttribute('data-gp-base') || 0; }
    var upCard = btn.closest('[data-gp-upsell]'); // drawer upsell card: scope + list price on the card itself
    if (upCard) { p.scope = upCard.getAttribute('data-gp-scope') || p.scope; p.base = +upCard.getAttribute('data-gp-base') || p.base; var ut = upCard.querySelector('.gp-upcard__title'); if (ut) p.title = ut.textContent.trim(); }
    if (!p.base) { var gp = GP(); p.base = gp && gp.b1g2 ? gp.b1g2.list : 0; if (!p.scope && btn.hasAttribute('data-fp-add')) p.scope = 'b1g2'; }
    return p;
  }

  // ---------- Add to Cart ----------
  function onAdd(btn) {
    var gp = GP(); if (!gp || !gp.state.known) return; // no ladder knowledge: let the theme do its normal thing
    lastTap = performance.now();
    var s = snapshot(); var p = productFor(btn);
    p.price = nextUnitPrice(p.scope, s, p.base);
    if (p.scope === 'b1g2') { s.n += 1; opt.n += 1; } else if (p.scope === 'readers3') { s.r += 1; opt.r += 1; } else { s.nonOffer += p.base; opt.nonOffer += p.base; }
    s.count += 1; s.baseSum += p.base; opt.count += 1; opt.baseSum += p.base;
    if (typeof window.open_slider_cart === 'function') { try { window.open_slider_cart(); } catch (e) {} }
    insertLine(p, s.n); paintTotals(s); paintProgress(s); paintUpsells(s); paintButtons(s);
    // button feedback: ADDED ✓ for a second, then the next label
    var main = $('button.gp-atc'); var target = btn.classList.contains('gp-atc') ? btn : null;
    if (target) { var next = gp.buttonLabel(s.n) || target.textContent; target.textContent = 'ADDED ✓'; target.setAttribute('data-gp-added', '1'); setTimeout(function () { if (target.getAttribute('data-gp-added')) { target.removeAttribute('data-gp-added'); target.textContent = next; } }, 1000); }
    else if (main && p.scope === 'b1g2') { main.textContent = gp.buttonLabel(s.n) || main.textContent; }
    window.GPInstant.lastOptimisticAt = performance.now();
    document.dispatchEvent(new CustomEvent('gp:optimistic', { detail: { type: 'add', ms: window.GPInstant.lastOptimisticAt - lastTap } }));
  }
  // ---------- drawer upsell "+": ONE handler (2026-10-12). The theme's addUpsellProduct no longer runs for these buttons. ----------
  // optimistic row at once -> one /cart/add.js (plain variant, no line properties, so the same variant merges into one line) ->
  // drawer re-render from the response. Busy until that render; a refusal shows a message on the button and restores it.
  function sectionId() { try { return typeof getCartDrawerSectionId === 'function' ? getCartDrawerSectionId() : 'cart-drawer'; } catch (e) { return 'cart-drawer'; } }
  function upsellAdd(btn) {
    var card = btn.closest('.cart_drawer_upsell');
    var sel = card && card.querySelector('.cart_drawer_upsell_variants');
    var vid = (sel && sel.value) || btn.getAttribute('data-variant-id');
    if (!vid) { fail('No variant'); return; }
    var sid = sectionId();
    btn.setAttribute('data-gp-busy', '1'); btn.setAttribute('aria-disabled', 'true');
    var label = btn.querySelector('.gp-upcard__added') ? null : btn; // text buttons get ADDED, icon buttons keep their icon
    var prevHTML = btn.innerHTML; if (label && !btn.querySelector('svg')) btn.textContent = 'ADDED';
    try { onAdd(btn); } catch (err) { if (window.console) console.warn('[GPInstant] optimistic add failed', err); }
    function fail(why) {
      $$('[data-gp-optimistic]').forEach(function (n) { n.remove(); });
      btn.removeAttribute('data-gp-busy'); btn.removeAttribute('aria-disabled');
      if (!btn.querySelector('svg')) btn.textContent = "Couldn't add · tap again"; else btn.innerHTML = prevHTML;
      btn.setAttribute('title', why || "Couldn't add"); btn.classList.add('gp-add-failed');
      if (card) { var m = card.querySelector('.gp-add-error'); if (!m) { m = document.createElement('div'); m.className = 'gp-add-error'; card.appendChild(m); } m.textContent = "Couldn't add — tap + again"; }
      if (window.console) console.warn('[GPInstant] upsell add failed:', why);
      if (typeof update_cart_content === 'function') update_cart_content();
    }
    (window.__gpNativeFetch || window.fetch)('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: [sid], sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { fail(res.json && (res.json.description || res.json.message) || ('HTTP ' + res.status)); return; }
        if (res.json && res.json.sections && typeof replaceCartDrawerContentFromSections === 'function') replaceCartDrawerContentFromSections(res.json.sections);
        else if (typeof update_cart_content === 'function') update_cart_content();
        if (typeof update_header_icon === 'function') update_header_icon();
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      })
      .catch(function (err) { fail(err && err.message); });
  }
  document.addEventListener('click', function (e) {
    // drawer upsell card: a tap on the image or title adds the pair (never a product-page visit); "View" is the only link
    var tap = e.target.closest && e.target.closest('#shopify-section-cart-drawer [data-gp-upsell-tap]');
    if (tap && e.target.closest && e.target.closest('.gp-upcard__view')) return; // "View" is a real link
    if (tap && !(e.target.closest && e.target.closest('.cart_drawer_upsell_add'))) { // the + has its own handler below
      e.preventDefault(); e.stopPropagation();
      var card = tap.closest('.cart_drawer_upsell'); var add = card && card.querySelector('.cart_drawer_upsell_add');
      if (add && !add.hasAttribute('data-gp-busy')) add.click();
      return;
    }
    var up = e.target.closest && e.target.closest('#shopify-section-cart-drawer .cart_drawer_upsell_add');
    if (up) {
      e.preventDefault(); e.stopImmediatePropagation(); // the inline onclick (theme addUpsellProduct) must not run: one request per tap
      if (up.hasAttribute('data-gp-busy')) return;
      var gp0 = GP(); if (!gp0 || !gp0.state.known) { try { addUpsellProduct(up); } catch (err) {} return; } // no ladder knowledge: theme path
      upsellAdd(up); return;
    }
    var btn = e.target.closest && e.target.closest('button.gp-atc, [data-fp-add], .rec-add, .productCard__button-atc[button-type="atc"], .collection-add-to-cart, [button-type="atc"]');
    if (!btn || btn.disabled || btn.classList.contains('is-disabled')) return;
    if (btn.closest('#shopify-section-cart-drawer')) return;
    try { onAdd(btn); } catch (err) { if (window.console) console.warn('[GPInstant] optimistic add failed', err); }
  }, true);

  // ---------- drawer + / - / remove: paint now, send once ----------
  var pendingQty = {};
  function lineOf(el) { return el.closest('.cart_drawer_item'); }
  // every line of the row's variant -> quantity 0 (grouped rows can hold several line keys)
  function removeKeys(keys) {
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    var sid = sectionId();
    return (window.__gpNativeFetch || window.fetch)('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [sid], sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.sections && typeof replaceCartDrawerContentFromSections === 'function') replaceCartDrawerContentFromSections(j.sections); else if (typeof update_cart_content === 'function') update_cart_content(); if (typeof update_header_icon === 'function') update_header_icon(); })
      .catch(function () { if (typeof update_cart_content === 'function') update_cart_content(); });
  }
  function onQty(el, delta, remove) {
    var line = lineOf(el); if (!line || line.hasAttribute('data-gp-optimistic')) return false;
    var key = el.getAttribute('data-id'); if (!key) return false;
    var qEl = line.querySelector('.cart_drawer_item_quantity');
    var p = pendingQty[key];
    // the row shows every line of this variant (data-gp-qty); the network call changes the FIRST line (data-quantity) by its key
    var lineQty = p ? p.lineQty : (+el.getAttribute('data-quantity') || 1);
    var shown = p ? p.shown : (+line.getAttribute('data-gp-qty') || +(qEl && qEl.textContent) || lineQty);
    var all = remove || (shown + delta <= 0);
    var nextLine = all ? 0 : Math.max(0, lineQty + delta), nextShown = all ? 0 : Math.max(0, shown + delta);
    if (!all && delta < 0 && lineQty === 0) return false; // the first line is already gone: let the render catch up
    var scope = line.getAttribute('data-gp-scope') || '';
    var s = snapshot(); var d = nextShown - shown;
    var unitBase = Math.round((+line.getAttribute('data-gp-base') || 0) / Math.max(1, shown));
    if (scope === 'b1g2') { s.n += d; opt.n += d; } else if (scope === 'readers3') { s.r += d; opt.r += d; } else { s.nonOffer += d * unitBase; opt.nonOffer += d * unitBase; }
    s.count += d; s.baseSum += d * unitBase; opt.count += d; opt.baseSum += d * unitBase;
    if (nextShown === 0) line.style.display = 'none'; else if (qEl) qEl.textContent = String(nextShown);
    paintTotals(s); paintProgress(s); paintUpsells(s); paintButtons(s);
    if (p) clearTimeout(p.timer);
    pendingQty[key] = { lineQty: nextLine, shown: nextShown, all: all, timer: setTimeout(function () {
      var st = pendingQty[key]; delete pendingQty[key];
      var keys = (line.getAttribute('data-gp-keys') || key).split(',').filter(Boolean); if (!keys.length) keys = [key];
      try {
        if (st.all) removeKeys(keys);
        else if (st.lineQty === 0) removeKeys([key]);
        else { el.setAttribute('data-quantity', String(st.lineQty - 1)); increaseCartItem(el); } // the theme reads data-quantity + 1 and sends one update
      } catch (err) { if (typeof update_cart_content === 'function') update_cart_content(); }
    }, 300) };
    return true;
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('#shopify-section-cart-drawer .cart_item_quantity_update, #shopify-section-cart-drawer .cart_drawer_item_remove');
    if (!el || el.classList.contains('gp-opt-disabled')) return;
    var gp = GP(); if (!gp || !gp.state.known) return;
    var isRemove = el.classList.contains('cart_drawer_item_remove');
    var delta = isRemove ? 0 : (/decrease/i.test(el.getAttribute('onclick') || '') || el === lineOf(el).querySelector('.cart_item_quantity_update') ? -1 : 1);
    if (onQty(el, delta, isRemove)) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  // ---------- rollback when the server refuses ----------
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?/.test(url)) p.then(function (res) {
        if (res && res.ok) return;
        $$('[data-gp-optimistic]').forEach(function (n) { n.remove(); });
        $$('.gp-opt-shell').forEach(function (n) { n.remove(); });
        $$('.cart_drawer_upsell_add[data-gp-busy]').forEach(function (b) { b.removeAttribute('data-gp-busy'); b.removeAttribute('aria-disabled'); });
        var b = $('button.gp-atc[data-gp-added], button.gp-atc'); if (b) { b.removeAttribute('data-gp-added'); b.textContent = "Couldn't add — tap to retry"; }
        if (typeof update_cart_content === 'function') update_cart_content();
      }, function () {});
    } catch (e) {}
    return p;
  };

  // after the real render lands, note the reconciliation time for the audit
  // the upsell carousel always starts at its first card after a render (the theme's swiper keeps an old offset otherwise)
  function resetCarousel() {
    var d = drawer(); if (!d) return;
    $$('.cart_drawer_upsells_swiper', d).forEach(function (el) {
      try { if (el.swiper && !el.swiper.destroyed) el.swiper.slideTo(0, 0); } catch (e) {}
      el.scrollLeft = 0; var w = el.querySelector('.swiper-wrapper'); if (w) { w.scrollLeft = 0; if (!el.swiper) w.style.transform = ''; }
    });
  }
  (function watchOpen() {
    var d = drawer(); if (!d) { document.addEventListener('DOMContentLoaded', watchOpen); return; }
    var was = d.classList.contains('slided');
    new MutationObserver(function () {
      var on = d.classList.contains('slided');
      if (on && !was) { var b = d.querySelector('.cart_drawer_main_container'); if (b) b.scrollTop = 0; resetCarousel(); }
      was = on;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  })();
  var carouselTimer = 0;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) { var nd = a[j]; if (nd.nodeType === 1 && (nd.matches && (nd.matches('.cart_drawer_upsells, .cart_drawer_upsells_swiper, [data-gp-upsell]') || nd.querySelector('.cart_drawer_upsells_swiper')))) { clearTimeout(carouselTimer); carouselTimer = setTimeout(resetCarousel, 60); setTimeout(resetCarousel, 400); return; } } }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart-drawer:open', function () { setTimeout(resetCarousel, 50); });
  new MutationObserver(function () {
    if (!window.GPInstant.lastOptimisticAt) return;
    var d = drawer(); if (!d) return;
    if ($('[data-gp-line]:not([data-gp-optimistic])', d) && !$('[data-gp-optimistic]', d)) {
      window.GPInstant.lastReconciledMs = performance.now() - lastTap; window.GPInstant.lastOptimisticAt = 0;
      document.dispatchEvent(new CustomEvent('gp:reconciled', { detail: { ms: window.GPInstant.lastReconciledMs } }));
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.GPInstant = { version: 4, resetCarousel: resetCarousel, snapshot: snapshot, totals: totals, upsellAdd: upsellAdd, removeKeys: removeKeys, paintUpsells: paintUpsells, lastOptimisticAt: 0, lastReconciledMs: null };
})();
